import { combineReducers } from "redux";
import { fieldScanningRootReducer } from "./fieldScaning/index";

export const harvestRootReducer = combineReducers({
  fieldScanning: fieldScanningRootReducer
});
